import styled from 'styled-components';

export default styled.div`
  position: relative;
  align-items: center;
  margin-bottom: 1rem;

  input[type='password'] {
    padding-right: 40px;
    width: 100%;
  }

  input[type='password']::-webkit-password-reveal {
    display: none;
  }

  input[type='password']::-ms-reveal,
  input[type='password']::-ms-clear {
    display: none;
  }
`;
